import React, { ReactNode } from 'react'

import style from './BasicModal.module.css'

import { ReactComponent as CrossIcon } from 'assets/icons/cross-icon.svg'
import { useForbidScroll, useKeyDown } from 'common/hooks'

type PropsType = {
  title: string
  children: ReactNode
  isOpen: boolean
  onClose: Function
}

export const BasicModal = ({ title, children, isOpen, onClose }: PropsType) => {
  useKeyDown(onClose, 'Escape')
  useForbidScroll(isOpen)

  if (!isOpen) {
    return null
  }

  const closeModal = () => {
    onClose()
  }

  return (
    <div className={style.shadow} onClick={closeModal}>
      <div className={style.box} onClick={e => e.stopPropagation()}>
        <header className={style.header}>
          <h2 className={style.title}>{title}</h2>
          <button aria-label="close modal" onClick={closeModal} className={style['cross-button']}>
            <CrossIcon className={style['cross-icon']} />
          </button>
        </header>
        {children}
      </div>
    </div>
  )
}
